var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-heart",
  "data-name": "Icon feather-heart",
  d: "M17.089,5.735a4.2,4.2,0,0,0-5.955,0l-.811.814-.811-.814a4.218,4.218,0,1,0-5.955,5.974l.811.814L10.323,18.5l5.955-5.974.811-.814a4.233,4.233,0,0,0,0-5.974Z",
  transform: "translate(-2.323 -4.497)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/whiteHeart.19734f92.svg";
export { SvgComponent as ReactComponent };